export const createAuthApi = (customFetch) => ({
    getProfile: async () => {
        try {
            const response = await customFetch('profile', {
                method: "POST"
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    },
    updateProfile: async (userData, photoId) => {
        const data = {
            surname: userData.surname,
            name: userData.name,
            patronymic: userData.patronymic,
            phone: userData.phone,
            sex: userData.sex,
            birthday: userData.birthday,
            country: userData.country,
            region: userData.region,
            city: userData.city,
            photoId: photoId,
            organization: userData.organization,
            position: userData.position,
            education: userData.education
        }
        try {
            const response = await customFetch('changeProfileData', {
                method: "POST",
                body: JSON.stringify(data)
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    },
    createUserPhoto: async (fileData) => {
        try {
            const response = await customFetch('createUserPhoto', {
                method: "POST",
                body: JSON.stringify(fileData)
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    },
    changeEmail: async (email) => {
        const data = { email: email }
        try {
            const response = await customFetch('changeEmail', {
                method: "POST",
                body: JSON.stringify(data)
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }
    },
    checkCodeOfEmailChanging: async (data) => {
        try {
            const response = await customFetch('checkCodeOfEmailChanging', {
                method: "POST",
                body: JSON.stringify(data)
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }
    },
    logOut: async () => {
        try {
            const response = await customFetch('logOut', {
                method: "POST"
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    }
});